import { apiPost } from "shared/services/apiRequest";

const bulkUpdateDeviceService = async (category, deviceIds, extra, data) =>
    apiPost(`/${category}/send-command/bulk`, { deviceIds, ...extra, ...data });

export const bulkUpdateSwitchDeviceService = (deviceIds, data) =>
    bulkUpdateDeviceService("switches", deviceIds, {}, data);

export const bulkUpdateBlowerDeviceService = (deviceIds, deviceType, data) =>
    bulkUpdateDeviceService("blowers", deviceIds, { deviceType }, data);
